/**
 * Ablageort der Anbietersitzung. Eigener Schlüssel neben recica.auth.session,
 * damit beide Hüte gleichzeitig aufliegen können.
 *
 * Bewusst ein winziges Modul ohne weitere Importe: die AppShell fragt hier nur
 * nach, ob sie den Einstieg in die Anbietersicht überhaupt anzeigen soll, und
 * soll dafür nicht den halben Anbieterbereich in ihr Bundle ziehen.
 */
export const PLATFORM_STORAGE_KEY = 'recica.platform.session';

/**
 * Nur ein Sichtbarkeits-Hinweis für das Menü, KEINE Zugangsprüfung.
 * Der echte Schutz liegt an der Signatur des Anbietertokens - wer sich hier
 * einen Eintrag in den Speicher schreibt, kommt damit an keinen Endpunkt.
 *
 * Folge für eine Kundeninstallation: dort existiert nie eine Anbietersitzung,
 * also sieht ein Kundenadministrator den Einstieg nie und erfährt gar nicht,
 * dass es eine Anbieterebene gibt.
 */
export function hasPlatformSession() {
  try {
    return Boolean(localStorage.getItem(PLATFORM_STORAGE_KEY));
  } catch {
    return false;
  }
}
